import { themeVar } from '../tenantTheme';

/**
 * The corner-radius scale, var-ified so a tenant can reshape the whole app.
 *
 * Previously the customer theme declared no `radii` at all, so the ~49 `borderRadius="md"` /
 * `"lg"` sites across cards, modals, tags, popovers and containers resolved straight to Chakra's
 * defaults with no override point. Chakra emits these as `--chakra-radii-*`, so wrapping the scale
 * here reaches every one of those call sites without touching a single component.
 *
 * Fallbacks are Chakra's own defaults verbatim (`@chakra-ui/theme/foundations/radius`), so nothing
 * moves until a tenant sets a value.
 *
 * Component-level keys still layer on top: `button.borderRadius`, `field.borderRadius` and
 * `input.borderRadius` fall back to `var(--chakra-radii-md)`, which now resolves through
 * `--peli-radii-md`. So setting `radii.md` moves buttons and fields too, while the component keys
 * override just that component.
 */
export default {
  none: themeVar('radii.none', '0'),
  sm: themeVar('radii.sm', '0.125rem'),
  base: themeVar('radii.base', '0.25rem'),
  md: themeVar('radii.md', '0.375rem'),
  lg: themeVar('radii.lg', '0.5rem'),
  xl: themeVar('radii.xl', '0.75rem'),
  '2xl': themeVar('radii.2xl', '1rem'),
  '3xl': themeVar('radii.3xl', '1.5rem'),
  full: themeVar('radii.full', '9999px'),
};
